import React from 'react';

export default function AttractionInsightCard({ description = '' }) {
  const displayDesc = description || 'People who prefer warm and emotionally expressive faces may feel naturally drawn to your calm and composed appearance.';

  return (
    <div style={{
      background: 'rgba(15, 23, 42, 0.4)',
      backdropFilter: 'blur(12px)',
      border: '1px solid rgba(236, 72, 153, 0.2)',
      borderRadius: '20px',
      padding: '1.75rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem',
      fontFamily: 'Inter, sans-serif',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{ position: 'absolute', top: '-40px', right: '-40px', width: '100px', height: '100px', background: 'rgba(236,72,153,0.15)', filter: 'blur(40px)', borderRadius: '50%' }}></div>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{ fontSize: '1.2rem' }}>✨</span>
        <div style={{ fontSize: '0.8rem', color: '#fbcfe8', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
          Attraction Insight
        </div>
      </div>
      
      <p style={{ margin: 0, color: '#e2e8f0', lineHeight: '1.6', fontSize: '1rem', fontWeight: '500', position: 'relative', zIndex: 1 }}>
        {displayDesc}
      </p>
    </div>
  );
}
